import { useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import {
  APP_TYPES,
  getAvailableAppTypes,
  getPageContentPermissions,
  resolveActiveAppType,
} from "utils/pageContentPermissions"

const usePageContentAppType = contentKey => {
  const location = useLocation()
  const navigate = useNavigate()
  const { userRole, accountType } = useSelector(state => state.Login)
  const searchParams = new URLSearchParams(location.search)
  const requestedAppType = searchParams.get("appType")

  const availableAppTypes = useMemo(
    () => getAvailableAppTypes(contentKey, userRole, accountType),
    [contentKey, userRole, accountType]
  )

  const [activeAppType, setActiveAppTypeState] = useState(
    resolveActiveAppType(requestedAppType, availableAppTypes)
  )

  useEffect(() => {
    setActiveAppTypeState(
      resolveActiveAppType(requestedAppType, availableAppTypes)
    )
  }, [requestedAppType, availableAppTypes])

  const usersPermissions = useMemo(
    () =>
      getPageContentPermissions(
        activeAppType,
        contentKey,
        userRole,
        accountType
      ),
    [activeAppType, contentKey, userRole, accountType]
  )

  const setActiveAppType = nextAppType => {
    if (!availableAppTypes.includes(nextAppType)) {
      return
    }
    const params = new URLSearchParams(location.search)
    params.set("appType", nextAppType)
    navigate(`${location.pathname}?${params.toString()}`, { replace: true })
    setActiveAppTypeState(nextAppType)
  }

  const hasAnyAccess = availableAppTypes.length > 0

  return {
    activeAppType,
    availableAppTypes,
    usersPermissions,
    setActiveAppType,
    hasAnyAccess,
    APP_TYPES,
  }
}

export default usePageContentAppType
